/**
 * Navigation Configuration
 * Defines the sidebar navigation structure for the Developer Dashboard
 */

export const DEV_NAV_ITEMS = [
  // A. Platform Overview
  {
    id: 'overview',
    label: 'Overview',
    path: '/PlatformEngineer/overview',
    group: 'A',
    sectionLabel: 'Platform Overview',
    icon: 'HiHome',
  },
  {
    id: 'activity',
    label: 'Activity Timeline',
    path: '/PlatformEngineer/overview/activity',
    group: 'A',
    sectionLabel: 'Platform Overview',
    icon: 'HiClock',
  },
  // B. Observability & Security
  {
    id: 'security',
    label: 'Security & Audit',
    path: '/PlatformEngineer/security',
    group: 'B',
    sectionLabel: 'Observability & Security',
    icon: 'HiShieldCheck',
  },
  {
    id: 'system-health',
    label: 'System Health',
    path: '/PlatformEngineer/security/health',
    group: 'B',
    sectionLabel: 'Observability & Security',
    icon: 'HiHeart',
  },
  // C. Users & Identity
  {
    id: 'identity',
    label: 'Users & Sessions',
    path: '/PlatformEngineer/identity',
    group: 'C',
    sectionLabel: 'Users & Identity',
    icon: 'HiUserGroup',
  },
  {
    id: 'deleted-users',
    label: 'Deleted Users',
    path: '/PlatformEngineer/identity/deleted',
    group: 'C',
    sectionLabel: 'Users & Identity',
    icon: 'HiTrash',
  },
  {
    id: 'otp-events',
    label: 'OTP & Login Events',
    path: '/PlatformEngineer/identity/otp',
    group: 'C',
    sectionLabel: 'Users & Identity',
    icon: 'HiKey',
  },
  // D. Clients & Organizations
  {
    id: 'organizations',
    label: 'Organizations',
    path: '/PlatformEngineer/clients/organizations',
    group: 'D',
    sectionLabel: 'Clients & Organizations',
    icon: 'HiBuildingOffice',
  },
  {
    id: 'clients',
    label: 'Clients & Employees',
    path: '/PlatformEngineer/clients',
    group: 'D',
    sectionLabel: 'Clients & Organizations',
    icon: 'HiUsers',
  },
  // E. Programs & Coaching
  {
    id: 'programs',
    label: 'Programs & Ratings',
    path: '/PlatformEngineer/programs',
    group: 'E',
    sectionLabel: 'Programs & Coaching',
    icon: 'HiAcademicCap',
  },
  {
    id: 'sessions',
    label: 'Sessions & Notes',
    path: '/PlatformEngineer/programs/sessions',
    group: 'E',
    sectionLabel: 'Programs & Coaching',
    icon: 'HiChatBubbleLeftRight',
  },
  {
    id: 'coaching',
    label: 'Coaching Activity',
    path: '/PlatformEngineer/programs/coaching',
    group: 'E',
    sectionLabel: 'Programs & Coaching',
    icon: 'HiUserCircle',
  },
  {
    id: 'tasks',
    label: 'Tasks',
    path: '/PlatformEngineer/programs/tasks',
    group: 'E',
    sectionLabel: 'Programs & Coaching',
    icon: 'HiClipboardDocumentList',
  },
  // F. Product Development & Audits
  {
    id: 'product-dev',
    label: 'Product Development',
    path: '/PlatformEngineer/product-dev',
    group: 'F',
    sectionLabel: 'Product Development & Audits',
    icon: 'HiRocketLaunch',
  },
  {
    id: 'product-submissions',
    label: 'Product Submissions & Checklists',
    path: '/PlatformEngineer/product-dev/submissions',
    group: 'F',
    sectionLabel: 'Product Development & Audits',
    icon: 'HiDocumentText',
  },
  {
    id: 'product-audits',
    label: 'Product Audits',
    path: '/PlatformEngineer/product-dev/audits',
    group: 'F',
    sectionLabel: 'Product Development & Audits',
    icon: 'HiCheckCircle',
  },
  // G. Content & Knowledge
  {
    id: 'knowledge',
    label: 'Knowledge Base',
    path: '/PlatformEngineer/knowledge',
    group: 'G',
    sectionLabel: 'Content & Knowledge',
    icon: 'HiBookOpen',
  },
  {
    id: 'knowledge-analytics',
    label: 'Knowledge Analytics',
    path: '/PlatformEngineer/knowledge/analytics',
    group: 'G',
    sectionLabel: 'Content & Knowledge',
    icon: 'HiChartBar',
  },
  // H. Messaging & Collaboration
  {
    id: 'messaging',
    label: 'Messages & Threads',
    path: '/PlatformEngineer/messaging',
    group: 'H',
    sectionLabel: 'Messaging & Collaboration',
    icon: 'HiChatBubbleLeftRight',
  },
  {
    id: 'private-chats',
    label: 'Private Chats',
    path: '/PlatformEngineer/messaging/private',
    group: 'H',
    sectionLabel: 'Messaging & Collaboration',
    icon: 'HiLockClosed',
  },
  // I. Templates & Document Bank
  {
    id: 'templates',
    label: 'Templates & Analytics',
    path: '/PlatformEngineer/templates',
    group: 'I',
    sectionLabel: 'Templates & Document Bank',
    icon: 'HiDocumentDuplicate',
  },
  {
    id: 'documents',
    label: 'Documents & Categories',
    path: '/PlatformEngineer/documents',
    group: 'I',
    sectionLabel: 'Templates & Document Bank',
    icon: 'HiFolder',
  },
  // J. Data Quality & Admin Tools
  {
    id: 'data-quality',
    label: 'Data Quality',
    path: '/PlatformEngineer/data-quality',
    group: 'J',
    sectionLabel: 'Data Quality & Admin Tools',
    icon: 'HiExclamationTriangle',
  },
  {
    id: 'dev-tools',
    label: 'Developer Tools',
    path: '/PlatformEngineer/tools',
    group: 'J',
    sectionLabel: 'Data Quality & Admin Tools',
    icon: 'HiCog6Tooth',
  },
  {
    id: 'collections',
    label: 'Collections Explorer',
    path: '/PlatformEngineer/collections',
    group: 'J',
    sectionLabel: 'Data Quality & Admin Tools',
    icon: 'HiCircleStack',
  },
  // K. HTTP Reference
  {
    id: 'http',
    label: 'HTTP Reference',
    path: '/PlatformEngineer/http',
    group: 'K',
    sectionLabel: 'HTTP Reference',
    icon: 'HiGlobeAlt',
  },
];

export const getNavItemsByGroup = group => DEV_NAV_ITEMS.filter(item => item.group === group);

export const getNavItemById = id => DEV_NAV_ITEMS.find(item => item.id === id);

export const getNavGroups = () => {
  const groups = new Map();
  DEV_NAV_ITEMS.forEach(item => {
    if (!groups.has(item.group)) {
      groups.set(item.group, {
        id: item.group,
        label: item.sectionLabel,
        items: [],
      });
    }
    groups.get(item.group).items.push(item);
  });
  return Array.from(groups.values());
};
